import React from 'react';
import { useSelector } from 'react-redux';

import { getLastChange } from './redux';
import { getCurrencyFormatter } from 'reducers/configs/settings';

export const headerComponent = (({ children }) => {
  const lastBalance = useSelector(getLastChange);
  const format = useSelector(getCurrencyFormatter);
  return (
    <>
      <span style={{margin: 4}} title={`On the last sale the amount of change was ${format(lastBalance)}`}>{format(lastBalance)}</span>
      {children}
    </>
  );
}) as React.FC;
